/* eslint-disable space-before-function-paren */
/* eslint-disable keyword-spacing */
/* eslint-disable no-unused-expressions */
/* eslint-disable space-before-blocks */
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
import ProgressBar from "progressbar.js";

export default class Sliders {
  constructor({ htmlBody }) {
    this.htmlBody = htmlBody;
    this.hBanner = this.htmlBody.find(".home-banner");
    this.hBannerC = this.htmlBody.find(".home-banner-controls");
    this.pBanner = this.htmlBody.find(".page-banner");
    this.pBanner2 = this.htmlBody.find(".page-banner-2__slider");
    this.hPropertyList = this.htmlBody.find(".home_property_list--slider");
    this.proBar = this.htmlBody.find(".banner--carousel__progress");
    this.gallery = this.htmlBody.find(".section__gallery__container");
    this.oProjects = this.htmlBody.find(".section__other-project__list");
    this.fpSlider = this.htmlBody.find(".section__floorplans__slider");
    this.awardsSlider = this.htmlBody.find(
      ".section__awards-accolades__slider"
    );
    this.homeNewsSlider = this.htmlBody.find(".home_news--slider");
    this.init();
  }

  init = () => {
    this.hBanner.length && this.hBannerC && this.homeBanner(); // Home Listing Projects
    this.hPropertyList.length && this.homePropertyList(); // Home Property List
    this.pBanner.length && this.pageBanner(); // page Banner
    this.pBanner2.length && this.pageBanner2(); // page Banner 2
    this.gallery.length && this.galleryCarousel(); // Gallery
    this.oProjects.length && this.otherProjects(); // before footer other projects
    this.fpSlider.length && this.floorplans();
    this.awardsSlider.length && this.awards();
    this.homeNewsSlider.length && this.newsSlider();

    //Payments Plan
    const payslider = new Swiper(".project__payment-plans__list", {
      loop: false,
      slidesPerView: 3,
      spaceBetween: 40,
      breakpoints: {
        539: {
          slidesPerView: 1.5,
          spaceBetween: 20, // Adjust the number of slides per view for smaller screens
        },
        768: {
          slidesPerView: 2.5,
          spaceBetween: 20, // Adjust the number of slides per view for smaller screens
        },
        // Add more breakpoints as needed
        1024: {
          spaceBetween: 30,
          slidesPerView: 3, // Adjust the number of slides per view for screens wider than 768px
        },
      },
      // Navigation arrows
      navigation: {
        nextEl:
          ".section__payment-plans .carousel__buttons__btn-next--external",
        prevEl:
          ".section__payment-plans .carousel__buttons__btn-prev--external",
      },
    });
  };

  homeBanner = () => {
    const interleaveOffset = 0.5;

    const sos = {
      init: false,
      loop: true,
      speed: 900,
      spaceBetween: 0,
      loopedSlides: 3,
      touchRatio: 0.4,
      allowTouchMove: false,
      watchSlidesProgress: true,
      on: {
        init() {
          setTimeout(() => {
            $(".search__property--home").fadeIn();
            $(".banner--carousel__pagination").addClass("inn");
          }, 500);
        },
        progress() {
          const swiper = this;
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < swiper.slides.length; i++) {
            const slideProgress = swiper.slides[i].progress;
            const innerOffset = swiper.width * interleaveOffset;
            const innerTranslate = slideProgress * innerOffset;
            swiper.slides[i].querySelector(
              ".banner--carousel__slide-image"
            ).style.transform = `translate3d(${innerTranslate}px, 0, 0)`;
          }
        },
        touchStart() {
          const swiper = this;
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < swiper.slides.length; i++) {
            swiper.slides[i].style.transition = "";
          }
        },
        setTransition(speed) {
          const swiper = this;
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < swiper.slides.length; i++) {
            swiper.slides[i].style.transition = `${speed}ms`;
            swiper.slides[i].querySelector(
              ".banner--carousel__slide-image"
            ).style.transition = `${speed}ms`;
          }
        },
      },
    };

    const ps = {
      loop: true,
      grabCursor: true,
      slidesPerView: 1,
      spaceBetween: 0,
      loopedSlides: 3,
      touchRatio: 0.1,
      speed: 1000,
      slideToClickedSlide: false,
      // watchSlidesProgress: true,
      // autoplay: {
      //   enabled: true,
      //   disableOnInteraction: false,
      //   delay: 7000,
      // },
      navigation: {
        nextEl: ".carousel__buttons__btn-next",
        prevEl: ".carousel__buttons__btn-prev",
      },
      breakpointsInverse: true,
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        990: {
          slidesPerView: 3,
        },
      },
    };

    const p = new Swiper(this.hBannerC, ps);
    const s = new Swiper(this.hBanner, sos);
    if (this.proBar.length) {
      const pb = new ProgressBar.Line(".banner--carousel__progress", {
        strokeWidth: 1,
        // easing: 'easeOut',
        duration: 7000,
        color: "#ffffff",
        trailColor: "#D8D8D870",
        trailWidth: 1,
        svgStyle: {
          width: "100%",
          height: "1px",
        },
      });
      s.on("init", () => pb.animate(1));
      s.on("slideChangeTransitionStart", () => {
        pb.set(0);
      });
      s.on("slideChangeTransitionEnd", () => pb.animate(1));
    }
    s.init();

    if (this.hBannerC.length) {
      p.controller.control = s;
    }
  };

  homePropertyList = () => {
    new Swiper(this.hPropertyList, {
      loop: false,
      slidesPerView: "auto",
      navigation: {
        nextEl: ".carousel__buttons__btn-next",
        prevEl: ".carousel__buttons__btn-prev",
      },
    });
  };

  pageBanner = () => {
    const interleaveOffset = 0.5;
    const setAutoPlay = this.pBanner.data("bannerautoplay");
    const pos = {
      init: false,
      loop: setAutoPlay,
      speed: 900,
      spaceBetween: 0,
      // grabCursor: true,
      allowTouchMove: false,
      watchSlidesProgress: true,
      autoplay: {
        enabled: setAutoPlay,
        disableOnInteraction: false,
        delay: 7000,
      },
      navigation: {
        nextEl: ".carousel__buttons__btn-next",
        prevEl: ".carousel__buttons__btn-prev",
      },
      on: {
        progress() {
          const swiper = this;
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < swiper.slides.length; i++) {
            const slideProgress = swiper.slides[i].progress;
            const innerOffset = swiper.width * interleaveOffset;
            const innerTranslate = slideProgress * innerOffset;
            swiper.slides[i].querySelector(
              ".banner--carousel__slide-image"
            ).style.transform = `translate3d(${innerTranslate}px, 0, 0)`;
          }
        },
        touchStart() {
          const swiper = this;
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < swiper.slides.length; i++) {
            swiper.slides[i].style.transition = "";
          }
        },
        setTransition(speed) {
          const swiper = this;
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < swiper.slides.length; i++) {
            swiper.slides[i].style.transition = `${speed}ms`;
            swiper.slides[i].querySelector(
              ".banner--carousel__slide-image"
            ).style.transition = `${speed}ms`;
          }
        },
      },
    };

    const s = new Swiper(this.pBanner, pos);

    if (this.proBar.length) {
      const pb = new ProgressBar.Line(".banner--carousel__progress", {
        strokeWidth: 1,
        // easing: 'easeOut',
        duration: 7000,
        color: "#ffffff",
        trailColor: "#D8D8D870",
        trailWidth: 1,
        svgStyle: {
          width: "100%",
          height: "1px",
        },
      });
      s.on("init", () => pb.animate(1));
      s.on("slideChangeTransitionStart", () => {
        pb.set(0);
      });
      s.on("slideChangeTransitionEnd", () => pb.animate(1));
    }
    s.init();
  };

  pageBanner2 = () => {
    const interleaveOffset = 0.5;
    const setAutoPlay = this.pBanner.data("bannerautoplay");
    const pos = {
      init: false,
      loop: setAutoPlay,
      speed: 900,
      spaceBetween: 0,
      allowTouchMove: false,
      watchSlidesProgress: true,
      autoplay: {
        enabled: setAutoPlay,
        disableOnInteraction: false,
        delay: 7000,
      },
      navigation: {
        nextEl: ".carousel__buttons__btn-next",
        prevEl: ".carousel__buttons__btn-prev",
      },
      on: {
        progress() {
          const swiper = this;
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < swiper.slides.length; i++) {
            const slideProgress = swiper.slides[i].progress;
            const innerOffset = swiper.width * interleaveOffset;
            const innerTranslate = slideProgress * innerOffset;
            swiper.slides[i].querySelector(
              ".page-banner-2__slider__slide-image"
            ).style.transform = `translate3d(${innerTranslate}px, 0, 0)`;
          }
        },
        touchStart() {
          const swiper = this;
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < swiper.slides.length; i++) {
            swiper.slides[i].style.transition = "";
          }
        },
        setTransition(speed) {
          const swiper = this;
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < swiper.slides.length; i++) {
            swiper.slides[i].style.transition = `${speed}ms`;
            swiper.slides[i].querySelector(
              ".page-banner-2__slider__slide-image"
            ).style.transition = `${speed}ms`;
          }
        },
      },
    };

    const s = new Swiper(this.pBanner2, pos);
    s.init();
  };

  galleryCarousel = () => {
    new Swiper(this.gallery, {
      loop: false,
      slidesPerView: "auto",
      spaceBetween: 0,
      freeMode: true,
      navigation: {
        nextEl: ".carousel__buttons__btn-next",
        prevEl: ".carousel__buttons__btn-prev",
      },
    });
  };

  otherProjects = () => {
    const spv = this.oProjects.data("slidesview");
    const sb = this.oProjects.data("spacebetween");
    new Swiper(this.oProjects, {
      loop: false,
      slidesPerView: spv,
      spaceBetween: sb,
      // navigation: {
      //   nextEl: ".carousel__buttons__btn-next",
      //   prevEl: ".carousel__buttons__btn-prev",
      // },
      breakpoints: {
        1200: {
          spaceBetween: 20,
        },
        1060: {
          slidesPerView: 2,
        },
        767: {
          spaceBetween: 0,
          slidesPerView: "auto",
        },
      },
    });
  };

  floorplans = () => {
    const s = new Swiper(this.fpSlider, {
      loop: false,
      slidesPerView: 1,
      // effect: 'fade',
      navigation: {
        nextEl: ".carousel__buttons__btn-next--external",
        prevEl: ".carousel__buttons__btn-prev--external",
      },
    });

    const list = this.fpSlider.closest(".section__floorplans__container");
    const l = new Swiper(
      list.find(".section__floorplans__content__wrapper").children(),
      {
        loop: false,
        direction: "vertical",
        slidesPerView: 1,
        autoHeight: true,
      }
    );

    s.controller.control = l;
    l.controller.control = s;
  };

  awards = () => {
    const s = new Swiper(this.awardsSlider, {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 0,
      autoHeight: true,
      speed: 1000,
      // slidesOffsetAfter: 250,
      breakpoints: {
        // 1440: {
        //   slidesOffsetAfter: 500,
        // },
        // 820: {
        //   slidesOffsetAfter: 100,
        // },
        // 768: {
        //   slidesOffsetAfter: 39,
        // },

        // 540: {
        //   slidesOffsetAfter: 10,
        // },
        767: {
          spaceBetween:15
        }
      },
      navigation: {
        nextEl: ".carousel__buttons__btn-next--external",
        prevEl: ".carousel__buttons__btn-prev--external",
      },
    });

    const list = this.awardsSlider.closest(
      ".section__awards-accolades__container"
    );

    if ($(window).width() > 767) {
      const l = new Swiper(
        list.find(".section__awards-accolades__content__wrapper").children(),
        {
          loop: false,
          direction: "vertical",
          slidesPerView: 1,
          touchRatio: 0.2,
          speed: 200
          // autoHeight: true,
          // slidesOffsetAfter: 200,
        }
      );

      s.controller.control = l;
      l.controller.control = s;
    } else {
      const l = new Swiper(
        list.find(".section__awards-accolades__content__wrapper").children(),
        {
          loop: false,
          direction: "horizontal",
          slidesPerView: 1,
          touchRatio: 0.2,
          speed: 800,
          // autoHeight: true,
          effect: "fade",
          fadeEffect: {
            crossFade: true,
          },
        }
      );
      s.controller.control = l;
      l.controller.control = s;
    }

    // s.controller.control = l;
    // l.controller.control = s;
  };

  newsSlider = () => {
    new Swiper(this.homeNewsSlider, {
      loop: false,
      slidesPerView: "auto",
      spaceBetween: 0,
      navigation: {
        nextEl: ".carousel__buttons__btn-next",
        prevEl: ".carousel__buttons__btn-prev",
      },
      breakpointsInverse: true,
      breakpoints: {
        768: {
          spaceBetween: 30,
          slidesPerView: 3,
        },
      },
    });
  };
}
